jQuery(document).ready(function($) {
    if (typeof stripePaymentData != 'undefined') {

        // German error texts from Stripe.js, the buyer sees them below the card form
        var stripe = Stripe(stripePaymentData.pk, {locale: 'de'});

        // the server creates the PaymentIntent when the buyer pays and names it when the bank asks for 3-D Secure,
        // the request after that confirms this one (until 11/2026 every visit of step 4 created a PaymentIntent)
        var paymentIntentId = null;

        // global function to enable or disable loading animation of all payment buttons
        var handleLoadingButtons = function(enable) {
            $('.dnPaymentSelect-button').each(function() {
                $(this).enableLoadingAnimation(enable);
            });
        };

        var checkAvailabilityThen = function(callback, onConnectionError) {
            fetch(stripePaymentData.checkAvailabilityUrl, {
                method: "GET",
                redirect: "follow"
            }).then((response) => {
               if (response.url === stripePaymentData.checkAvailabilityUrl) {
                   callback();
               } else {
                   // the check once more, not response.url: fetch followed the redirect already and used up the
                   // message why (tickets gone), the second check redirects again and step 1 shows it
                   window.location = stripePaymentData.checkAvailabilityUrl;
               }
            }, () => {
                if (onConnectionError) {
                    onConnectionError();
                }
            });
        }

        /*
            Handles Payment Request API
        */

        var paymentRequest = stripe.paymentRequest({
            country: 'DE',
            currency: 'eur',
            total: {
                label: stripePaymentData.shopping_card_title,
                amount: stripePaymentData.amount,
            },
            requestPayerName: true,
            requestPayerEmail: true,
        });

        // Check the availability of the Payment Request API first and show correct payment method
        paymentRequest.canMakePayment().then(function(result) {
            console.log(result);
            if (result) {
                var allowGooglePay = result.googlePay ?? false;
                var allowApplePay = result.applePay ?? false;

                $('.stripe-google-pay').toggleClass('hidden', !allowGooglePay);
                $('.stripe-apple-pay').toggleClass('hidden', !allowApplePay);

            }
        });

        // on click of a payment request
        $(document).on('click', '.dnPaymentSelect-button-paymentRequest', function() {
            $(this).enableLoadingAnimation(true);
            checkAvailabilityThen(() => console.debug('Proceed with payment request'));
            paymentRequest.show()
        });

        // handle event cancel
        paymentRequest.on('cancel', function(ev) {
            handleLoadingButtons(false);
        });

        // handle event paymentmethod
        paymentRequest.on('paymentmethod', function(ev) {
            var paymentMethod = ev.paymentMethod.id;

            $.ajax({
                method: "POST",
                url: stripePaymentData.card_process_url,
                data: {
                    'payment_intent': paymentIntentId || '',
                    'payment_method': paymentMethod,
                    // the total of the wallet sheet, the server charges nothing else
                    'amount': stripePaymentData.amount
                },
            })
                .done(function(response) {
                    if (response.status === 'success') {
                        ev.complete('success');
                        window.location.replace(stripePaymentData.return_url);
                    } else if (response.status === 'amount_changed') {
                        // nothing is charged, the reloaded page shows the new total
                        ev.complete('fail');
                        location.reload();
                    }  else {
                        ev.complete('fail');
                        window.location.replace(stripePaymentData.rejected_payment_url);
                    }
                })
                .fail(function() {
                    window.location.replace(stripePaymentData.rejected_payment_url);
                });
        });


        // Create an instance of Elements.
        var elements = stripe.elements();

        var style = {
            base: {
                color: '#32325d',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        };

        // Create an instance of the card Element.
        var cardElement = elements.create('card', {style: style});
        var btnCreditCardPay = $("#dnPaymentStripe-creditCardPay");
        var errorMessageCreditCard = $("#dnPaymentSelect-description-errorsStripeCreditCard");
        var errorMessageCreditCardDefault = errorMessageCreditCard.text().trim();

        // Add an instance of the card Element into the `card-element` <div>.
        cardElement.mount('#dnPaymentSelect-description-stripeCreditCardElement');

        // checks while the buyer types, Stripe.js names the problem
        cardElement.on('change', function(event) {
            if (event.error) {
                showCreditCardError(event.error.message);
            } else {
                errorMessageCreditCard.attr('hidden', true);
            }
        });

        $(document).on('click', '#' + btnCreditCardPay.attr('id'), function() {
            btnCreditCardPay.enableLoadingAnimation(true);
            errorMessageCreditCard.attr('hidden', true);

            checkAvailabilityThen( () => {
                // an exception of Stripe.js ends up in the second handler instead of a button spinning forever
                Promise.resolve().then(() => stripe.createPaymentMethod({
                    type: 'card',
                    card: cardElement,
                    billing_details: {
                        name: stripePaymentData.lastname,
                    },
                })).then(stripeCreditCardPaymentMethodHandler, () => {
                    stripeCreditCardPaymentMethodHandler({error: {type: 'integration_error'}});
                });
            }, () => failCreditCardPayment('availability', null));
        });

        function stripeCreditCardPaymentMethodHandler(result) {
            if (result.error) {
                failCreditCardPayment('payment_method', result.error);

                if (window.checkoutInProgress) {
                    window.checkoutInProgress = false;
                }
            } else {
                stripeCreditCardHandleServerResponse(result.paymentMethod.id);
            }
        }

        function stripeCreditCardRequiresActionHandler(result) {
            if (result.error) {
                failCreditCardPayment('3ds', result.error);
            } else {
                stripeCreditCardHandleServerResponse(result.paymentIntent.payment_method);
            }
        }

        // the card payment stopped in the browser: the buyer sees why, the order log gets Stripe's codes
        function failCreditCardPayment(stage, error) {
            btnCreditCardPay.enableLoadingAnimation(false);
            // Stripe's own text, else a general one (no connection, exception in Stripe.js)
            showCreditCardError(error && error.message ? error.message : stripePaymentData.card_failed_text);
            reportCreditCardError(stage, error, {});
        }

        function showCreditCardError(message) {
            errorMessageCreditCard.text(message || errorMessageCreditCardDefault).attr('hidden', false);
        }

        // type and codes only, Stripe's message and anything else stay here; the server checks the values once more
        function reportCreditCardError(stage, error, details) {
            if (!stripePaymentData.card_error_url) {
                return;
            }

            var data = new URLSearchParams({stage: stage});

            ['type', 'code', 'decline_code', 'param'].forEach((key) => {
                if (error && typeof error[key] === 'string') {
                    data.append(key, error[key]);
                }
            });

            $.each(details, (key, value) => {
                data.append(key, value);
            });

            // a beacon still goes out when the page reloads right after
            if (!navigator.sendBeacon || !navigator.sendBeacon(stripePaymentData.card_error_url, data)) {
                $.post(stripePaymentData.card_error_url, data.toString());
            }
        }

        function stripeCreditCardHandleServerResponse(paymentMethodId) {
            $.ajax({
                method: "POST",
                url: stripePaymentData.card_process_url,
                data: {
                    'payment_intent': paymentIntentId || '',
                    'payment_method': paymentMethodId,
                    // the total on the page, the server charges nothing else
                    'amount': stripePaymentData.amount
                },
            })
                .done(function(response) {
                    if (response.status == 'success') {
                        window.location.replace(stripePaymentData.return_url);
                    } else if(response.status == 'error_redirect') {
                        window.location.replace(stripePaymentData.return_url);
                    } else if(response.status == 'requires_action') {
                        paymentIntentId = response.payment_intent;
                        Promise.resolve().then(() => stripe.handleCardAction(
                            response.client_secret
                        )).then(stripeCreditCardRequiresActionHandler, () => {
                            stripeCreditCardRequiresActionHandler({error: {type: 'integration_error'}});
                        });
                    } else {
                        location.reload();
                    }
                })
                .fail(function(jqXHR, textStatus) {
                    // an error page or no answer: the order log gets the status, the reload shows the order as it is now
                    reportCreditCardError('server', null, {http_status: jqXHR.status, text_status: textStatus});
                    location.reload();
                });
        }
    }
});
